import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnInit, signal,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  ButtonComponent,
  ButtonOptions,
  DateComponent, DateOptions,
  FormComponent,
  ModalComponent,
  ModalOptions
} from "@shared/components";
import {DropdownComponent, DropdownOptions} from "@shared/components/dropdown/dropdown.component";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule, ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {NgOptimizedImage} from "@angular/common";
import {TextAreaComponent, TextAreaOptions} from "@shared/components/text-area/text-area.component";
import {assets, FILTER_TEXT_FOR_TEXTAREA} from '@core/constants';
import {Coding} from '@core/classes/other/coding';
import {APIService, DataService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {IllnessSearchComponent} from '@shared/components/dropdown/search/illness-search/illness-search.component';
import {TreatmentRecommendation} from '@core/classes/tables/treatment-recommendation';
import {ResponseSingle} from '@core/classes/other/response';

@Component({
  selector: 'ncp-add-treatment',
  imports: [
    ButtonComponent,
    FormsModule,
    ModalComponent,
    NgOptimizedImage,
    TextAreaComponent,
    ReactiveFormsModule
  ],
  templateUrl: './add-treatment.component.html',
  styleUrl: './add-treatment.component.scss',
})
export class AddTreatmentComponent implements OnInit, AfterViewInit {
  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('tFrm') protected treatmentFormEl?: NgForm;
  @ViewChild('addTreatmentButton') public addTreatmentButton!: ButtonComponent;

  @ViewChild('treatmentTxt') public treatmentTxt!: TextAreaComponent;

  protected readonly toastService = inject(ToastService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private apiService = inject(APIService);
  private patientService = inject(PatientService);
  private dataService = inject(DataService);

  protected data = model<any>();

  private _params = {};
  protected form: FormGroup = new FormGroup({
    description: new FormControl<string>('', [Validators.required]),
  }, {
    validators: [this.formValidator()]
  });

  formValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let errors: ValidationErrors | null = {};

      let description = (control as FormGroup).controls['description'];

      if(description.value === undefined || description.value === null || description.value === '') {
        description.setErrors({tr_descriptionInvalid: true});
        errors['tr_descriptionInvalid'] = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    }
  }

  getFormControl = (name: string) => {
    return this.form.get(name) as FormControl;
  }

  public btnTOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'tBtn',
      tooltip: 'add_treatment',
    })
  );

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.form,
      form: FormComponent,
      title: 'add_treatment',
      options: {
        animation: true,
        size: 'xl',
        fullscreen: "lg",
        backdrop: 'static',
        keyboard: false,
      },
      onClose: () => {this.onFormReset()}
    })
  );

  protected recommendationsOptions = signal<TextAreaOptions>(
    new TextAreaOptions({
      id: 'treatment_recommendations',
      label: {
        text: 'treatment_recommendations',
      },
      name: 'treatment_recommendations',
      formControl: this.getFormControl('description'),
      initialValue: '',
      pattern: FILTER_TEXT_FOR_TEXTAREA,
      required: true
    })
  );

  ngOnInit() {
    this.btnTOptions().onClick = (event) => {
      this.mod.options().onReset = this.onFormReset;
      this.addTreatmentButton.blur();
      this.mod.open();
    };

    this.modOptions().onSave = this.onSave;
  }

  onFormReset = () => {
    console.log('on reset form');
    this.form.reset();

    this.modOptions().errors = [];
  }

  ngAfterViewInit(): void {

  }

  onSave = () => {
    this.treatmentFormEl?.ngSubmit.emit();
  }

  validate = (): boolean => {
    Object.keys(this.form.controls).forEach((control) => {
      this.form.controls[control].markAsTouched();
    })

    return true;
  }

  onFormSubmit = () => {
    if(this.validate() && this.form.invalid) {
      console.log('this.form.is.invalid');
      this.modOptions().errors = this.form.errors!;
      this.mod.detectChanges();
      return;
    }

    this.modOptions().disableOnSave = true;
    let body = {
      description: (this.form.get('description') as FormControl).value,
      status: 1,
      version_id: this.patientService.version!.new,
    }

    this.apiService.call({
      path: '/treatment-recommendations',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.POST,
      body: body
    })?.subscribe((res: ResponseSingle<TreatmentRecommendation>) => {
      if(res && res.status?.toString() === '1') {
        let data = this.data()?.tblOptions().data
        data.unshift(res.data)
        if (this.data && this.data() && this.data().tbl && this.data().tbl.tableData) {
          this.data()!.tbl!.tableData! = data;
        }
        this.mod.close();
      }
    })
  }

  protected readonly assets = assets;
}
